export type RoleFilterOptions = {
    includeUnassignableRoles: boolean;
    onlyDelegatableRoles: boolean;
}

export type Role = {
    id: string;
    name: string;
    applicationSections: string[];
    isDelegated: boolean;
}

export type NewRole = {
    id: string;
}

export type PersonDelegate = {
    delegatePersonId: string;
    delegateName: string;
    delegateRoleId: string;
    createdDate: Date;
}

export type NewPersonDelegate = {
    delegatePersonId: string;
    delegateRoleId: string;
}

export type DeletePersonDelegate = {
    delegatePersonId: string;
    delegateRoleId: string;
}

export enum ApplicationRole {
    Administrator = "A35A9B77-341E-41BC-989C-3A2FB081E394",
    NetworkAdministrator = "7935A841-FA46-4887-BFD8-2AB1C6D7D481",
    DatabaseAdministrator = "245B40CC-C2B2-4FCA-94A8-A3C7E636D49B",
    Facilities = "ACB08868-ADD4-4FAC-95C9-A973811990A6",
    HR = "2F9D4D00-20D6-4E1B-873B-C79401314C01",
    Business = "7C5807C7-9091-4572-9357-CAF4E78CF19C",
    TTIWebsiteAdministrator = "9A813E9B-4649-440F-87D7-49683C125B57",
    Management = "04131888-75AD-48EC-B004-A935F1F2F56C",
    FinanceAdministrator = "9A433CC5-7EC6-4E78-A975-181ED1699B6A"
}
